<script>
import Layout from "../../layouts/main.vue";
import PageHeader from "@/components/page-header";
import appConfig from "../../../app.config";
import axios from 'axios';
import moment from 'moment';
import SwiperCore, { Pagination, Navigation } from "swiper";
import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/swiper-bundle.css";
import Swal from "sweetalert2";
import attributeProduct from "./attributeProduct.vue";
import { usePermissions } from '@/composables/usePermissions';   // ← Added this line

SwiperCore.use([Pagination, Navigation]);

export default {
    page: {
        title: "Products Details",
        meta: [
            {
                name: "description",
                content: appConfig.description,
            },
        ],
    },
    data() {
        return {
            role: localStorage.getItem('role'),
            title: "Products Details",
            items: [
                {
                    text: "Device Management",
                    href: "/",
                },
                {
                    text: "Products Details",
                    active: true,
                },
            ],
            product_info: [],
            categorylist: [],
            devicemodelList: [],
            colorList: [],
            capacityList: [],
            product_name: '',
            model_id: '',
            category_id: '',
            capacity_id: '',
            color_id: '',
            color_hex_code: '',
            owned: '',
            status: '0', // Default to enable
            image: '',
            ButtonSeen: true,
            url: '',
        };
    },
    
    setup() {
        // Initialize permissions composable
        const permissions = usePermissions();
        
        return {
            permissions,
        };
    },
    
    methods: {
        format_date(value){
            if (value) {
                return moment(String(value)).format('DD-MM-YYYY H:m:s')
            }
        },

        get_branch_by_id(){
            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
            axios.get(process.env.VUE_APP_API_BASEURL+'product/edit/'+this.$route.params.id)
            .then(response => {
                if (response) {
                    this.product_info = response.data;
                    if (this.product_info.length > 0) {
                        this.product_name = this.product_info[0].product_name;
                        this.image = this.product_info[0].image;
                        this.model_id = this.product_info[0].model_id;
                        this.category_id = this.product_info[0].category_id;
                        this.capacity_id = this.product_info[0].capacity_id;
                        this.color_id = this.product_info[0].color_id;
                        this.color_hex_code = this.product_info[0].color_hex_code;
                        this.owned = this.product_info[0].owned;
                        this.status = this.product_info[0].status ? this.product_info[0].status.toString() : '0';
                    }
                } 
                else {
                    Swal.fire({
                        title: "Error",
                        text: 'No record found.',
                        icon: 'warning',
                        showConfirmButton: false,
                    });
                }
            })
            .catch(error => {
                console.error('Error fetching product:', error);
                Swal.fire({
                    title: "Error",
                    text: error.message || 'Failed to fetch product details',
                    icon: 'error',
                });
            });
        },

        update_product(e) {
            e.preventDefault();
            
            // Determine if we're creating or updating
            const isEditing = typeof this.$route.params.id !== 'undefined';
            
            // Check permissions
            if (isEditing && !this.permissions.canUpdate?.value) {
                Swal.fire({
                    title: "Update Denied",
                    text: "You don't have permission to update products.",
                    icon: 'error',
                    confirmButtonText: 'OK'
                });
                return;
            }
            
            if (!isEditing && !this.permissions.canCreate?.value) {
                Swal.fire({
                    title: "Create Denied",
                    text: "You don't have permission to create new products.",
                    icon: 'error',
                    confirmButtonText: 'OK'
                });
                return;
            }
            
            // Validate required fields
            if (!this.product_name || !this.category_id || !this.model_id || !this.capacity_id || !this.color_id) {
                Swal.fire({
                    title: "Validation Error",
                    text: "Please fill in all required fields.",
                    icon: 'warning',
                    confirmButtonText: 'OK'
                });
                return;
            }

            const posting_ = {                
                product_name: this.product_name,
                model_id: this.model_id,
                category_id: this.category_id,
                capacity_id: this.capacity_id,
                color_id: this.color_id,
                color_hex_code: this.color_hex_code || '',
                owned: this.owned || '',
                status: this.status,
            };

            // Determine API endpoint
            this.url = isEditing 
                ? process.env.VUE_APP_API_BASEURL + 'product/update/' + this.$route.params.id
                : process.env.VUE_APP_API_BASEURL + 'product/create';

            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
            axios.post(this.url, posting_)
            .then(response => {
                if (response.status === 200) {
                    Swal.fire({
                        title: isEditing ? 'Updated Successfully' : 'Created Successfully',
                        text: response.data.message || 'Operation completed successfully',
                        icon: 'success',
                        showConfirmButton: false,
                        timer: 1500
                    });
                    
                    // If creating new, reset form
                    if (!isEditing) {
                        this.resetForm();
                    }
                    
                    // Navigate back after successful operation
                    setTimeout(() => {
                        this.$router.go(-1);
                    }, 1600);
                } else {
                    Swal.fire({
                        title: "Operation Failed",
                        text: response.data.message || 'Operation failed',
                        icon: 'warning',
                        showConfirmButton: false,
                    });
                }
            })
            .catch(error => {
                console.error('API Error:', error);
                Swal.fire({
                    title: "Error",
                    text: error.response?.data?.message || 'An error occurred. Please try again.',
                    icon: 'error',
                    confirmButtonText: 'OK'
                });
            });
        },

        // Reset form to initial state
        resetForm() {
            this.product_name = '';
            this.model_id = '';
            this.category_id = '';
            this.capacity_id = '';
            this.color_id = '';
            this.color_hex_code = '';
            this.owned = '';
            this.status = '0';
            this.image = '';
        },

        // Delete product method
        deleteProduct() {
            if (!this.permissions.canDelete?.value) {
                Swal.fire({
                    title: "Delete Denied",
                    text: "You don't have permission to delete products.",
                    icon: 'error',
                    confirmButtonText: 'OK'
                });
                return;
            }
            
            Swal.fire({
                title: 'Are you sure?',
                text: "You won't be able to revert this!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#d33',
                cancelButtonColor: '#3085d6',
                confirmButtonText: 'Yes, delete it!'
            }).then((result) => {
                if (result.isConfirmed) {
                    axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
                    axios.delete(process.env.VUE_APP_API_BASEURL + 'product/delete/' + this.$route.params.id)
                    .then(response => {
                        Swal.fire({
                            title: 'Deleted!',
                            text: response.data.message || 'Product has been deleted.',
                            icon: 'success',
                            confirmButtonText: 'OK'
                        }).then(() => {
                            this.$router.go(-1);
                        });
                    })
                    .catch(error => {
                        Swal.fire({
                            title: 'Error',
                            text: error.response?.data?.message || 'Failed to delete product.',
                            icon: 'error',
                            confirmButtonText: 'OK'
                        });
                    });
                }
            });
        },

        //raw data----------------------------------------------------------
        get_category(){
            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
            axios.get(process.env.VUE_APP_API_BASEURL+'category/raw_data')
            .then(response => {
                if (response) {
                    this.categorylist = response.data;
                } 
                else {
                    this.messageBag = ['No record.'];
                }
            })
            .catch(error => {
                console.error('Error fetching categories:', error);
            });
        },

        get_model(){
            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
            axios.get(process.env.VUE_APP_API_BASEURL+'device_model/raw_data')
            .then(response => {
                if (response) {
                    this.devicemodelList = response.data;
                } 
                else {
                    this.messageBag = ['No record.'];
                }
            })
            .catch(error => {
                console.error('Error fetching models:', error);
            });
        },

        get_capacity(){
            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
            axios.get(process.env.VUE_APP_API_BASEURL+'capacity/raw_data')
            .then(response => {
                if (response) {
                    this.capacityList = response.data;
                } 
                else {
                    this.messageBag = ['No record.'];
                }
            })
            .catch(error => {
                console.error('Error fetching capacities:', error);
            });
        },

        get_color(){
            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
            axios.get(process.env.VUE_APP_API_BASEURL+'color/raw_data')
            .then(response => {
                if (response) {
                    this.colorList = response.data;
                } 
                else {
                    this.messageBag = ['No record.'];
                }
            })
            .catch(error => {
                console.error('Error fetching colors:', error);
            });
        },

        selectNewCategory(category_id) {
            this.get_category();
            this.category_id = category_id;
        },

        selectNewModel(model_id) {
            this.get_model();
            this.model_id = model_id;
        },

        selectNewCapacity(capacity_id) {
            this.get_capacity();
            this.capacity_id = capacity_id;
        },

        selectNewColor(color_id) {
            this.get_color();
            this.color_id = color_id;
        },
        //raw data----------------------------------------------------------

        imageRoot(){
            return process.env.VUE_APP_IMAGE_BASEURL;
        },
        
        // Check if user can add attributes (category, model, etc.)
        canAddAttributes() {
            return this.permissions.canCreate?.value || this.permissions.canUpdate?.value;
        },
    },

    computed: {
        // Determine if we're in edit mode
        isEditMode() {
            return typeof this.$route.params.id !== 'undefined';
        },
        
        // Button text based on mode and permissions
        submitButtonText() {
            if (this.isEditMode && this.permissions.canUpdate?.value) {
                return 'Update Product';
            } else if (!this.isEditMode && this.permissions.canCreate?.value) {
                return 'Create Product';
            }
            return 'Submit';
        },
        
        // Button color based on action
        submitButtonColor() {
            return this.isEditMode ? 'btn-warning' : 'btn-primary';
        },
        
        // Page title based on mode
        pageTitle() {
            return this.isEditMode ? 'Edit Product' : 'Create New Product';
        },
    },

    components: {
        Layout,
        PageHeader,
        Swiper,
        SwiperSlide,
        attributeProduct,
    },

    mounted() { 
        // Set page title based on mode
        this.title = this.pageTitle;
        
        // Update breadcrumb items
        if (this.isEditMode) {
            this.items[1].text = 'Edit Product';
        } else {
            this.items[1].text = 'Create Product';
        }
        
        // Load data if in edit mode and user has permission
        if (this.isEditMode) {
            if (this.permissions.canRead?.value || this.permissions.canUpdate?.value) {
                this.get_branch_by_id();
            } else {
                // Redirect or show error if no permission
                Swal.fire({
                    title: "Access Denied",
                    text: "You don't have permission to view this product.",
                    icon: 'error',
                    confirmButtonText: 'OK'
                }).then(() => {
                    this.$router.go(-1);
                });
            }
        }
        
        // Load dropdown data
        this.get_category();
        this.get_model();
        this.get_capacity();
        this.get_color();
    },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    
    <!-- Permission check -->
    <div v-if="!permissions.canRead?.value && !permissions.canCreate?.value && !permissions.canUpdate?.value" 
         class="alert alert-danger m-3">
      <i class="ri-error-warning-line align-middle me-2"></i>
      You don't have permission to access this page.
    </div>
    
    <div v-else class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-header">
          </div>
          
          <div class="card-body">
            <div class="row gx-lg-5">
              <!-- Image Section -->
              <div class="col-xl-4 col-md-8 mx-auto" v-if="isEditMode && image">
                <div class="product-img-slider sticky-side-div">
                  <swiper
                    class="product-thumbnail-slider p-2 rounded bg-light"
                    :loop="false"
                    :spaceBetween="24"
                    :navigation="{
                      nextEl: '.swiper-button-next',
                      prevEl: '.swiper-button-prev',
                    }"
                    :thumbs="{
                      swiper: {
                        loop: false,
                        spaceBetween: 10,
                        slidesPerView: 1,
                        freeMode: true,
                        watchSlidesProgress: true,
                      },
                    }"
                  >
                    <swiper-slide>
                      <img :src="`${ imageRoot() }` + image" alt="" class="img-fluid d-block" />
                    </swiper-slide>                                                        
                  </swiper>            
                </div>
              </div>
              <!-- end col -->

              <!-- Form Section -->
              <div class="col-xl-8">
                <div class="mt-xl-0 mt-5">
                  <div class="d-flex">
                    <div class="flex-grow-1">
                      <h4 v-if="isEditMode">
                        <span class="badge badge-soft-primary badge-border">{{ product_name }}</span>
                      </h4>
                      <hr class="my-4 text-muted">
                      
                      <div class="live-preview">
                        <form @submit="update_product" class="row g-3">
                          <!-- Product Name -->
                          <div class="col-md-12">
                            <label for="product_name" class="form-label">Product Name <span class="text-danger">*</span></label>
                            <input v-model='product_name' 
                                   type="text" 
                                   class="form-control" 
                                   id="product_name"
                                   :disabled="!permissions.canUpdate?.value && isEditMode"
                                   required />
                          </div>

                          <!-- Category -->
                          <div class="col-md-6">
                            <div class="d-flex justify-content-between align-items-center">
                              <label for="category" class="form-label">Category <span class="text-danger">*</span></label>
                              <a v-if="canAddAttributes()"
                                 href="#" 
                                 data-bs-toggle="modal" 
                                 data-bs-target="#addCategoryModal"
                                 class="text-primary small">
                                <i class="ri-add-circle-line me-1"></i>Add New
                              </a>
                            </div>
                            <select v-model="category_id" 
                                    class="form-select mb-3" 
                                    :disabled="!permissions.canUpdate?.value && isEditMode"
                                    required>
                              <option value="">--- Select Category ---</option>
                              <option v-for="(item, index) in categorylist" 
                                      :key="index" 
                                      :value="item.id">
                                {{ item.name }}
                              </option>
                            </select>
                          </div>
                          
                          <!-- Model -->
                          <div class="col-md-6">
                            <div class="d-flex justify-content-between align-items-center">
                              <label for="model" class="form-label">Model <span class="text-danger">*</span></label>
                              <a v-if="canAddAttributes()"
                                 href="#" 
                                 data-bs-toggle="modal" 
                                 data-bs-target="#addModelModal"
                                 class="text-primary small">
                                <i class="ri-add-circle-line me-1"></i>Add New
                              </a>
                            </div>
                            <select v-model="model_id" 
                                    class="form-select mb-3" 
                                    :disabled="!permissions.canUpdate?.value && isEditMode"
                                    required>
                              <option value="">--- Select Model ---</option>
                              <option v-for="(item, index) in devicemodelList" 
                                      :key="index" 
                                      :value="item.id">
                                {{ item.model_name }}
                              </option>
                            </select>
                          </div>

                          <!-- Capacity -->
                          <div class="col-md-6">
                            <div class="d-flex justify-content-between align-items-center">
                              <label for="capacity" class="form-label">Capacity <span class="text-danger">*</span></label>
                              <a v-if="canAddAttributes()"
                                 href="#" 
                                 data-bs-toggle="modal" 
                                 data-bs-target="#addCapacityModal"
                                 class="text-primary small">
                                <i class="ri-add-circle-line me-1"></i>Add New
                              </a>
                            </div>
                            <select v-model="capacity_id" 
                                    class="form-select mb-3" 
                                    :disabled="!permissions.canUpdate?.value && isEditMode"
                                    required>
                              <option value="">--- Select Capacity ---</option>
                              <option v-for="(item, index) in capacityList" 
                                      :key="index" 
                                      :value="item.id">
                                {{ item.name }}
                              </option>
                            </select>
                          </div>
                          
                          <!-- Color -->
                          <div class="col-md-6">
                            <div class="d-flex justify-content-between align-items-center">
                              <label for="color" class="form-label">Color <span class="text-danger">*</span></label>
                              <a v-if="canAddAttributes()"
                                 href="#" 
                                 data-bs-toggle="modal" 
                                 data-bs-target="#addColorModal"
                                 class="text-primary small">
                                <i class="ri-add-circle-line me-1"></i>Add New
                              </a>
                            </div>
                            <select v-model="color_id" 
                                    class="form-select mb-3" 
                                    :disabled="!permissions.canUpdate?.value && isEditMode"
                                    required>
                              <option value="">--- Select Color ---</option>
                              <option v-for="(item, index) in colorList" 
                                      :key="index" 
                                      :value="item.id">
                                {{ item.name }}
                              </option>
                            </select>
                          </div>

                          <!-- Color Hex Code -->
                          <div class="col-md-6">
                            <label for="color_hex_code" class="form-label">Color Hex Code</label>
                            <input v-model='color_hex_code' 
                                   type="text" 
                                   class="form-control" 
                                   id="color_hex_code"
                                   :disabled="!permissions.canUpdate?.value && isEditMode" />
                          </div>
                          
                          <!-- Pre Owned -->
                          <div class="col-md-6">
                            <label for="owned" class="form-label">Pre Owned</label>
                            <input v-model='owned' 
                                   type="text" 
                                   class="form-control" 
                                   id="owned"
                                   :disabled="!permissions.canUpdate?.value && isEditMode" />
                          </div>
                          
                          <!-- Status -->
                          <div class="col-md-12" v-if="isEditMode">
                            <label for="status" class="form-label">Status</label>
                            <div class="list-group">
                              <label class="list-group-item" :class="{'opacity-50': !permissions.canUpdate?.value}">
                                <input class="form-check-input fs-14 mt-0 align-middle me-1"
                                       name="status"
                                       v-model="status"
                                       type="radio"
                                       value="0"
                                       :disabled="!permissions.canUpdate?.value" />
                                Enable
                              </label>
                              <label class="list-group-item" :class="{'opacity-50': !permissions.canUpdate?.value}">
                                <input class="form-check-input fs-14 mt-0 align-middle me-1"
                                       name="status"
                                       v-model="status"
                                       type="radio"
                                       value="1"
                                       :disabled="!permissions.canUpdate?.value" />
                                Disable
                              </label>
                            </div>
                          </div>
                          
                          <!-- Action Buttons -->
                          <div class="col-12">
                            <div class="text-end">
                              <a @click="$router.go(-1)" class="btn btn-light me-2">
                                <i class="ri-arrow-go-back-line align-middle me-1"></i> Back
                              </a>
                              
                              <!-- Submit button with dynamic text and permission check -->
                              <button v-if="(isEditMode && permissions.canUpdate?.value) || (!isEditMode && permissions.canCreate?.value)"
                                      type="submit" 
                                      class="btn" 
                                      :class="submitButtonColor"
                                      :disabled="(!product_name || !category_id || !model_id || !capacity_id || !color_id)">
                                <i class="ri-save-line align-middle me-1"></i> {{ submitButtonText }}
                              </button>
                              
                              <!-- Disabled button if no permission -->
                              <button v-else
                                      type="button"
                                      class="btn btn-secondary"
                                      disabled>
                                <i class="ri-forbid-line align-middle me-1"></i> No Permission
                              </button>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>                  
                  </div>
                </div>
              </div>
              <!-- end col -->
            </div>
            <!-- end row -->
          </div>
          <!-- end card body -->
        </div>
        <!-- end card -->
      </div>
      <!-- end col -->
    </div>
    
    <!-- Attribute Modals (only if user has permission) -->
    <attributeProduct 
      v-if="canAddAttributes()"
      @category-added="selectNewCategory" 
      @model-added="selectNewModel" 
      @capacity-added="selectNewCapacity" 
      @color-added="selectNewColor">
    </attributeProduct>
    
  </Layout>
</template>

<style scoped>
.opacity-50 {
  opacity: 0.5;
}

.badge-border {
  border: 1px solid #dee2e6;
}

.btn:disabled {
  cursor: not-allowed;
}

.list-group-item {
  cursor: pointer;
}

.list-group-item input:disabled {
  cursor: not-allowed;
}

.badge {
  font-size: 0.75em;
}
</style>